import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Profile = lazy(() => import('./Profile'));

const ProfileRoute: FuseRouteItemType = {
    path: 'profile',
    element: <Profile />,
    settings: {
        layout: {
            config: {
                toolbar: {
                    title: 'Profile',
                }
            }
        }
    }
}

export default ProfileRoute;